var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21818 6.50003L12.8513 0.866918C13.0496 0.668592 13.0496 0.347045 12.8513 0.148745C12.6529 -0.0495561 12.3314 -0.0495815 12.1331 0.148745L6.49999 5.78186L0.866916 0.148745C0.66859 -0.0495815 0.347044 -0.0495815 0.148744 0.148745C-0.049556 0.347071 -0.0495814 0.668617 0.148744 0.866918L5.78182 6.5L0.148744 12.1331C-0.0495814 12.3314 -0.0495814 12.653 0.148744 12.8513C0.247894 12.9504 0.377868 13 0.507843 13C0.637817 13 0.767766 12.9504 0.866941 12.8513L6.49999 7.2182L12.1331 12.8513C12.2322 12.9504 12.3622 13 12.4922 13C12.6221 13 12.7521 12.9504 12.8513 12.8513C13.0496 12.653 13.0496 12.3314 12.8513 12.1331L7.21818 6.50003Z",
    fill: "#D4AF37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4f49961f.svg";
export { ForwardRef as ReactComponent };